export const ERROR_TYPE_INFO_COMPONENT = "error-info-component";
export const INFO_TYPE_INFO_COMPONENT = "info-info-component";
export const SUCCESS_TYPE_INFO_COMPONENT = "success-info-component";
export const WARNING_TYPE_INFO_COMPONENT = "warning-info-component";
